import { css, cx } from '@eti/styles';
import Icon from '../icon/Icon';
import { jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = css`
  align-items: center;
  display: flex;
  height: inherit;
  justify-content: center;
  position: absolute;
  width: inherit;
`;
const iconStyles = css`
  position: relative;
`;
const StackedIcon = ({
  className,
  icons,
  ...rest
}) => /*#__PURE__*/_jsx("div", {
  ...rest,
  className: cx('etiStackedIcon', iconStyles, className),
  children: icons.map((icon, index) => /*#__PURE__*/_jsx("div", {
    className: cx('etiIcon__wrapper', wrapperStyles),
    children: typeof icon === 'string' ? /*#__PURE__*/_jsx(Icon, {
      className: `etiStackedIcon__icon etiStackedIcon__icon--${index}`,
      id: icon
    }) : /*#__PURE__*/_jsx(Icon, {
      className: icon.className,
      color: icon.color,
      height: icon.height,
      id: icon.id,
      size: icon.size,
      top: icon.top,
      width: icon.width
    })
  }, typeof icon === 'string' ? icon : icon.id))
});
export default StackedIcon;
//# sourceMappingURL=StackedIcon.js.map